import { Component, Input } from '@angular/core';

import { ImageComponent } from '@atoms/image/image.component';
import { ParagraphComponent } from '@atoms/paragraph/paragraph.component';
import { ModalMainContentComponent } from '@molecules/modal/modal-main-content/modal-main-content.component';
import { ModalHeaderComponent } from '@molecules/modal/modal-header/modal-header.component';
import { ModalMainComponent } from '@molecules/modal/modal-main/modal-main.component';
import { ModalTitleComponent } from '@molecules/modal/modal-title/modal-title.component';

@Component({
  selector: 'app-online-form-accessories-modal',
  imports: [ImageComponent, ParagraphComponent, ModalMainContentComponent, ModalHeaderComponent, ModalMainComponent, ModalTitleComponent],
  templateUrl: './online-form-accessories-modal.component.html',
  styleUrl: './online-form-accessories-modal.component.scss',
})
export class OnlineFormAccessoriesModalComponent {
  @Input() data?: { title: string; description: string; image: string };
}
